import { Expose, Transform, Type } from "class-transformer";
import { CreatePurchaseOrderLineDto } from "@/core/features/purchase-orders/create-purchase-order-line.dto";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { PurchaseOrderProjectDestinationEnum } from "@altertec_gparn/lib";

export class CreatePurchaseOrderDto {
  @Expose()
  supplierId: string;

  @Expose()
  companyId: string;

  @Expose()
  operativeUnitId: string;

  @Expose()
  warehouseId: string;

  @Expose()
  projectId?: string;

  @Expose()
  projectDestination?: PurchaseOrderProjectDestinationEnum;

  @Expose()
  @Type(() => CreatePurchaseOrderLineDto)
  lines?: CreatePurchaseOrderLineDto[];

  @Expose()
  addressId: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  date: string;
}
